import React, { useEffect, useState } from 'react';
import { Grid, Paper, Dialog, Typography, withStyles, Divider } from '@material-ui/core';
import { getDownloadButtons, checkAvailableKeys, checkIfAvailable, alternativeDownloads, styles } from './DownloadPage';
import { snackActions } from '../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../sc-utilities';
import AppLogoLoading from '../sc-logo';
import { connect } from 'react-redux';
import WorkPC from './WorkPC';
import WorkMacOS from './WorkMacOS';

const pcDownloadButtons = (translations) => [
    { downloadKey: 'work_pc', name: translations['work_iso'] || 'Work ISO' },
    { downloadKey: 'work_win_app', name: translations['work_win_app'] || 'Windows application' },
    { downloadKey: 'work_chromebook_arm', name: translations['work_chromebook_arm'] || 'Chromebook (Arm)' },
];

const macOsDownloadButtons = (translations) => [
    { downloadKey: 'work_osx_intel', name: translations['work_osx'] || 'Work macOS (Catalina)' },
    { downloadKey: 'work_osx_m1', name: translations['work_osx_m1'] || 'Mac with Apple chip' },
    { downloadKey: 'work_osx_app', name: translations['work_osx_app'] || 'macOS application' },
];

const Work = (props) => {
    const { classes, translations, permissions, activeCustomerID } = props;
    const [availableKeys, setAvailableKeys] = useState();
    const [privateAvailableKeys, setPrivateAvailableKeys] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchKeys = async () => {
            const res = await checkAvailableKeys(activeCustomerID).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            const privateRes = await checkAvailableKeys(activeCustomerID, false).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            if (res?.status === 200 && privateRes?.status === 200) {
                setAvailableKeys(res.data.result.data);
                setPrivateAvailableKeys(privateRes.data.result.data);
            }
            setLoading(false);
        };
        fetchKeys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translations]);

    return (
        <Paper className={classes.root}>
            {hasPermission(permissions, 'binary_image_download') && (
                <>
                    <div className={classes.customToolbar}>
                        <div className={classes.tableTitle}>
                            {BackButton(translations, classes.customTooltip)}
                            <Typography className={classes.typography}>
                                {translations['downloads'] || 'Downloads'}
                            </Typography>
                        </div>
                    </div>
                    {!loading && (
                        <>
                            <Grid container direction="row" className={classes.grid}>
                                <WorkPC classes={classes} translations={translations} />
                                <Grid item ms={6} lg={6} container direction="row" justify="center" alignItems="center">
                                    {getDownloadButtons(
                                        pcDownloadButtons(translations),
                                        availableKeys,
                                        classes,
                                        privateAvailableKeys,
                                        activeCustomerID,
                                        translations
                                    )}
                                    {checkIfAvailable(
                                        availableKeys,
                                        pcDownloadButtons(translations),
                                        alternativeDownloads,
                                        classes,
                                        translations,
                                        privateAvailableKeys
                                    )}
                                </Grid>
                            </Grid>
                            <Divider orientation="vertical" flexItem className={classes.divider} />
                            <Grid container direction="row" className={classes.grid}>
                                <WorkMacOS classes={classes} translations={translations} />
                                <Grid item ms={6} lg={6} container direction="row" justify="center" alignItems="center">
                                    {getDownloadButtons(
                                        macOsDownloadButtons(translations),
                                        availableKeys,
                                        classes,
                                        privateAvailableKeys
                                    )}
                                    {checkIfAvailable(
                                        availableKeys,
                                        macOsDownloadButtons(translations),
                                        alternativeDownloads,
                                        classes,
                                        translations,
                                        privateAvailableKeys
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Dialog
                        disableBackdropClick={true}
                        disableEscapeKeyDown={false}
                        open={loading}
                        PaperProps={{
                            classes: {
                                root: classes.loadingScreen,
                            },
                        }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                </>
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(Work));
